var _circle, _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.01,
    r: 20,
    transform: "matrix(-1 1.74846e-07 1.74846e-07 1 20 20)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.318 20.7658L14.7894 20.7658C14.3533 20.7658 14 20.4166 14 19.9851C14 19.554 14.3533 19.2048 14.7894 19.2048L27.318 19.2048L23.4206 15.316C23.1271 15.0082 23.1353 14.5239 23.4403 14.2261C23.744 13.928 24.2324 13.9242 24.5415 14.2175L29.7712 19.4371C30.0763 19.7415 30.0763 20.2315 29.7712 20.5356L24.5415 25.7552C24.4546 25.8465 24.3479 25.9147 24.2304 25.9558C24.1509 25.9833 24.0667 25.9985 23.9811 25.9999C23.7677 26.0037 23.5626 25.922 23.4118 25.7741C23.2603 25.6263 23.1767 25.4236 23.1781 25.213C23.1787 25.111 23.1998 25.0114 23.2386 24.919C23.28 24.8211 23.3418 24.7315 23.4206 24.6567L27.318 20.7658Z",
    fill: "#DDDEE0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 18,
    rx: 1,
    transform: "matrix(1 -1.74846e-07 -1.74846e-07 -1 10 29)",
    fill: "#DDDEE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHeader);
export default __webpack_public_path__ + "static/media/menu_header.5ba22de1dfd673822fbbb06c86bb8e57.svg";
export { ForwardRef as ReactComponent };